/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import Content from "components/Content";
import Label from "components/Label";
import React, { FC, useState } from "react";
import { FiChevronDown as ChevronDown } from "react-icons/fi";
import { BsDash as Dash } from "react-icons/bs";

import Collapsable from "components/Collapsable";
import { useRouter } from "next/router";
import Footer from "../../../../../public/footer-desktop.svg";
import styles from "./styles.module.scss";
import { Opening } from "./types";

type Props = {
  openings: Opening[];
  loading: boolean;
};

const JoinUs: FC<Props> = ({ openings = [], loading }) => {
  const [collapsed, setCollapsed] = useState(false);

  const { push } = useRouter();

  return (
    <>
      <Content id="careers" containerClassName={styles.wrapper}>
        <Collapsable
          disabled={loading}
          onSelect={() => setCollapsed(!collapsed)}
          open={!loading && !collapsed}
          className={styles.collapsable}
          header={
            <div className={styles.collapsableHeader}>
              <Label
                className={styles.title}
                variant="h2-centered"
                color="primary2"
              >
                Come join our team to transform the home services industry!
              </Label>
              <div className={styles.collapseIndicator}>
                {collapsed && <ChevronDown className={styles.icon} />}
                {!collapsed && <Dash className={styles.icon} />}
                <Label color="primary2">
                  {loading
                    ? "Loading openings"
                    : collapsed
                    ? "Click to expand"
                    : "Collapse"}
                </Label>
              </div>
            </div>
          }
        >
          <div className={styles.openings}>
            {openings.map(({ area, jobs }) => (
              <div className={styles.area}>
                <Label variant="small-capitalized" color="primary">
                  {area}
                </Label>
                <div className={styles.titles}>
                  {jobs.map(({ title, location, postUrl }) => (
                    <div
                      onClick={() => {
                        push(postUrl);
                      }}
                      className={styles.jobTitle}
                    >
                      <Label breakWord variant="h4" color="primary2">
                        {title}
                      </Label>
                      <Label color="primary2">{location}</Label>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </Collapsable>
      </Content>
      <Footer className={styles.footer} />
    </>
  );
};

export default JoinUs;
